"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ronciglione": {
    "e2cdad53": [{
      "hkey": "2d0f6ada",
      "slug": "punta-del-lago-poggio-cavaliere",
      "name": "Punta del Lago-Poggio Cavaliere",
      "primary": true,
      "skipSearch": false
    }],
    "lago-di-vico": [{
      "hkey": "2d0f6ada",
      "slug": "punta-del-lago-poggio-cavaliere",
      "name": "Punta del Lago-Poggio Cavaliere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;